export default __webpack_public_path__ + "static/media/p11_m.25c2aa95.png";